/* unplugin-vue-components disabled */import script from "./AddConfigModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddConfigModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__